<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter">
<img alt="MRS. SLATER AND SUE WATCH BUNNY AND HARRY BRING IN THE BOX." class="calibre16" id="id-7891929519208952251" src="Images/img0001.jpg" title="MRS. SLATER AND SUE WATCH BUNNY AND HARRY BRING IN THE BOX."/>
<span class="caption">MRS. SLATER AND SUE WATCH BUNNY AND HARRY BRING IN THE BOX.</span>
</div>
<div class="center"><i class="calibre17">Bunny Brown and His Sister Sue at Christmas Tree Cove.</i><br class="calibre5"/>
<i class="calibre17">Frontispiece</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?fc521ebc